import { gql } from '@sc/graphql';

export const GQL_QUERY_INDEX_QUERY_MESSAGES = gql(`
  query IndexQueryMessages ($input: IndexQueryMessagesInput!) {
    indexQueryMessages (input: $input) {
      items {
        ... QueryMessageFragment
      }
      lastEvaluatedKey
    }
  }
`);

export const GQL_MUTATION_CREATE_QUERY = gql(`
  mutation CreateQuery ($input: CreateQueryInput!) {
    createQuery (input: $input) {
      query {
        uuid
      }
      user {
        ... QueryMessageFragment
      }
      model {
        ... QueryMessageFragment
      }
    }
  }
`);

export const GQL_FRAGMENT_QUERY_MESSAGE = gql(`
  fragment QueryMessageFragment on QueryMessage {
    uuid
    role
    retrievalToken
    parts {
      thought
      executableCode {
        language 
        code
      }
      text
    }
    files {
      uuid
      name
      mimeType
    }
    status
    createdAt
    feedback {
      qualitative 
      quantitative
    }
    groundingChunks {
      uuid
      title
      description
      url
      hostedIntegrationPath
      favicon
      source {
        type
      }
      file {
        name
      }
    }
    citations {
      chunkId
      snippet
      startIndex
      endIndex
    }
  }
`);

export const GQL_MUTATION_CREATE_QUERY_MESSAGE = gql(`
  mutation CreateQueryMessage ($input: CreateQueryMessageInput!) {
    createQueryMessage (input: $input) {
      user {
        ... QueryMessageFragment
      }
      model {
        ... QueryMessageFragment
      }
    }
  }
`);

export const GQL_QUERY_READ_QUERY_MESSAGE = gql(`
  query ReadQueryMessage ($input: ReadQueryMessageInput!) {
    readQueryMessage (input: $input) {
      ... QueryMessageFragment
    }
  }
`);

export const GQL_MUTATION_CREATE_FILE = gql(`
  mutation CreateFile ($input: CreateFileInput!) {
    createFile (input: $input) {
      uuid
      src
      uploadInstructions {
        url
        key
        keyPrefix
      }
    }
  }
`);

export const GQL_MUTATION_DELETE_FILE = gql(`
  mutation DeleteFile ($uuid: String!) {
    deleteFile (uuid: $uuid)
  }
`);

export const GQL_MUTATION_UPDATE_QUERY_MESSAGE = gql(`
  mutation UpdateQueryMessage ($input: UpdateQueryMessageInput!) {
    updateQueryMessage (input: $input)
  }
`);

export const GQL_QUERY_INDEX_GROUNDING_CHUNKS = gql(`
  query IndexGroundingChunks ($input: IndexGroundingChunksInput!) {
    indexGroundingChunks (input: $input) {
      uuid
      title
      url
      hostedIntegrationPath
      favicon
      source {
        type
      }
      file {
        name
      }
    }
  }
`);

export const GQL_FRAGMENT_PROJECT_QUERY_LIST = gql(`
  fragment ProjectQueryList on ProjectQuery {
    uuid
    title
    isBookmarked
  }
`);

export const GQL_QUERY_INDEX_QUERIES = gql(`
  query IndexQueries ($input: IndexQueryInput!) {
    indexQueries (input: $input) {
      items {
        ... ProjectQueryList
      }
      pagination {
        lastPage
      }
    }
  }
`);

export const GQL_FRAGMENT_PROJECT_QUERY = gql(`
  fragment ProjectQuery on ProjectQuery {
    uuid
    title
    isBookmarked
    rateLimit {
      queriesConsumed
      queryMultiplier
      queriesPerUserPerHour
      queriesUsedThisHour
      queriesRemaining
      resetsAt
    }
  }
`);

export const GQL_MUTATION_UPDATE_QUERY = gql(`
  mutation UpdateQuery ($input: UpdateQueryInput!) {
    updateQuery (input: $input) {
      ... ProjectQuery
    }
  }
`);

export const GQL_QUERY_READ_QUERY = gql(`
  query ReadQuery ($uuid: String!) {
    readQuery (uuid: $uuid) {
      ... ProjectQuery
    }
  }
`);